<template>
  <div v-if="item">
    <fields-list :item="item" :fields="fields" />
    <div class="save-group">
      <button class="btn btn-warning btn-icon" @click="updateItem">
        <span class="ti-save"></span>{{ 'save' | setText('Сохранить') }}
      </button>
    </div>
  </div>
</template>

<script>
import { cardUpdate, cardContent, pushLang } from "@/plugins/functions";

export default {
  data: () => ({
    cardLink: "texts",
    cardSetLink: "texts",
    item: null,
    fields: [
      {
        col: ' col-12 col-md-12',
        key: "key",
        label: "key",
        type: "field",
        readonly: true,
      },
      {
        col: ' col-12 col-md-12',
        key: "name",
        label: "name",
        type: "field",
        textType: "text",
        isMultiLang: true,
      },
      {
        col: ' col-12 col-md-12',
        key: "group",
        label: "group",
        type: "static_radio",
        items: [
          { id: null, title: "empty" },
          { id: 'labes', title: "labes" },
          { id: 'placeholders', title: "placeholders" },
          { id: 'buttons', title: "buttons" },
          { id: 'descriptions', title: "descriptions" },
        ],
      },
      {
        col: ' col-12 col-md-12',
        key: "platform",
        label: "platform",
        type: "static_radio",
        items: [
          { id: 'admin', title: "admin" },
          { id: 'client', title: "client" },
          { id: 'guardian', title: "guardian" },
        ],
      },
    ],
  }),

  props: ["id"],
  async created() {
    // this.pushLang();
    this.item = await this.cardContent(this.cardLink, this.id);
  },
  methods: {
    cardUpdate: cardUpdate,
    cardContent: cardContent,
    pushLang: pushLang,
    async updateItem() {
      let item = await this.cardUpdate(this.cardSetLink, this.item, this.fields);
      // if (item){
      //   this.item = item;
      // }
    },
  },
};
</script>
<style>
</style>
